import { useEffect, useState } from 'react';

export interface MultiStepForm {
	currentStepIndex: number;
	latestStepIndexVisited: number;
	setLatestStepIndexVisited: (index: number) => void;
	isFirstStep: boolean;
	isLastStep: boolean;
	goTo: (index: number) => void;
	next: () => void;
	prev: () => void;
}

export function useMultiStepForm(steps: number): MultiStepForm {
	const [currentStepIndex, setCurrentStepIndex] = useState(0);
	const [latestStepIndexVisited, setLatestStepIndexVisited] = useState(0);

	useEffect(() => {
		if (currentStepIndex > latestStepIndexVisited) {
			setLatestStepIndexVisited(currentStepIndex);
		}
	}, [currentStepIndex, latestStepIndexVisited]);

	function next() {
		setCurrentStepIndex(i => {
			if (i >= steps - 1) return i;
			return i + 1;
		});
	}

	function prev() {
		setCurrentStepIndex(i => {
			if (i <= 0) return i;
			return i - 1;
		});
	}

	function goTo(index: number) {
		setCurrentStepIndex(index);
	}

	return {
		currentStepIndex,
		latestStepIndexVisited,
		setLatestStepIndexVisited,
		isFirstStep: currentStepIndex === 0,
		isLastStep: currentStepIndex === steps - 1,
		goTo,
		next,
		prev,
	};
}
